import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const formSubmitGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const allowedRoute = localStorage.getItem('allowedRoute');
  const currentRoute = state.url;   // Current URL user is trying to access

  if (allowedRoute === currentRoute) {
    return true;
  }

  const saasPartnerKey = localStorage.getItem('saasPartnerKey');
  let redirectRoute = '/';

  // Redirect based on route
  if (currentRoute.includes('/ting-next')) {
    redirectRoute = `/ting-offer/${saasPartnerKey}`;
  }
  else if (currentRoute.includes('/leakbot-next')) {
    redirectRoute = `/leakbot-offer/${saasPartnerKey}`;
  }

  router.navigate([redirectRoute]);
  return false;
};